import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import api from '../../../../../api';

import {
  loadOrder,
  payLater,
  canPayLater,
} from '../../../../../redux/modules/singleOrder';

import Button from '../../../../shared/Button/Button';
import Price from '../../../../shared/Price/Price';
import A from '../../../../shared/Anchor/Anchor';
import { primary_dark15 } from '../../../../shared/lib/colors';

import './DettaglioOrdine.scss';
import IubendaCookieSolution from '../../../../../utils/iubenda';
import { ImageDispatcher } from '../../../../shared/ImageDispatcher/ImageDispatcher';

class DettaglioOrdine extends Component {
  componentDidMount() {
    this.props.loadOrder(this.props.params.id);
  }

  renderSubtotal(product) {
    return <Price amount={product.price * product.quantity} />;
  }

  renderCartItems() {
    const { order } = this.props;

    return order.items.map(product => {
      return (
        <tr key={product.id} className="prodotto-carrello">
          <td>
            <ImageDispatcher src={product.image} alt={product.name} />
          </td>
          <td>{product.name}</td>
          <td className="text-right">
            <Price amount={product.price} />
          </td>
          <td className="text-right">{product.quantity}</td>
          <td className="subtotal text-right">
            {this.renderSubtotal(product)}
          </td>
        </tr>
      );
    });
  }

  renderCoupon(coupon, items) {
    if (coupon && (coupon.discountPercent || coupon.discountFixed)) {
      let discountName = coupon.name;
      let discountDescription = '';
      let discountAmount = 0;

      if (coupon.discountFixed) {
        discountAmount = coupon.discountFixed;
        discountDescription = (
          <span>
            {' '}
            - <Price amount={coupon.discountFixed} />
          </span>
        );
      }

      if (coupon.discountPercent) {
        discountAmount = items.reduce((total, item) => {
          if (item.couponShippedDiscount) {
            return total + item.couponShippedDiscount;
          }
          return total;
        }, 0);
        discountDescription = ' - ' + coupon.discountPercent + '%';
      }

      return (
        <tr>
          <td></td>
          <td colSpan="3">
            Coupon "{discountName}" {discountDescription}
          </td>
          <td className="subtotal discount-subtotal text-right">
            - <Price amount={discountAmount} />
          </td>
        </tr>
      );
    }
    return null;
  }

  render() {
    const { order, primaryColor } = this.props;
    const token = localStorage.getItem('token');

    const printInvoiceObj = api.printInvoice(order.id);
    const downloadUrlInvoice = printInvoiceObj.endpoint + '?t=' + token;

    const printCreditMemoObj = api.printCreditMemo(order.id);
    const downloadUrlCreditMemo = printCreditMemoObj.endpoint + '?t=' + token;

    return (
      <div className="dettaglio-ordine">
        <h2>Dettaglio ordine #{order.id}</h2>

        <div className="row">
          <div className="col-sm-4 order-md-2">
            <div className="account-box">
              <h3>Stato ordine</h3>
              <div className="order-status">
                <p>Data: {moment(order.date).format('DD/MM/YYYY HH:mm')}</p>
                <hr />
                <p>
                  Stato pagamento:{' '}
                  <span
                    className="status"
                    style={{ color: primary_dark15(primaryColor) }}
                  >
                    {order.payment.status}
                  </span>
                </p>
                <p>Tipo di pagamento: {order.payment.typeName}</p>
                {/*{!!order.payment.transactionNumber && 
                  <p>Codice di transazione: {order.payment.transactionNumber}</p>
                }*/}
                {!!canPayLater(order) && (
                  <Button
                    className="btn btn-pay-now"
                    onClick={() => {
                      this.props.payLater(order.id, order.payment.typeName);
                    }}
                  >
                    Paga ora
                  </Button>
                )}
                <hr />
                {!!order.shipping.typeName &&
                order.shipping.typeName === 'PICKUP_AT_PHARMACY' ? (
                  <div>
                    <p>
                      Spedizione:{' '}
                      <span
                        className="status"
                        style={{ color: primary_dark15(primaryColor) }}
                      >
                        RITIRO IN FARMACIA
                      </span>
                    </p>
                    {!!order.shipping.lockerNumber && (
                      <p>Codice Locker: {order.shipping.lockerNumber}</p>
                    )}
                  </div>
                ) : (
                  <div>
                    <p>
                      Stato di spedizione:{' '}
                      <span
                        className="status"
                        style={{ color: primary_dark15(primaryColor) }}
                      >
                        {!!order.shipping.status &&
                        order.shipping.status.toLowerCase() === 'bloccato'
                          ? 'In attesa'
                          : order.shipping.status}
                      </span>
                    </p>
                    <p>Corriere: {order.shipping.typeName}</p>
                    {!!order.shipping.trackingNumber && (
                      <p>
                        Codice di tracciamento: {order.shipping.trackingNumber}
                      </p>
                    )}
                  </div>
                )}
                {!!order.invoice.number && (
                  <span>
                    <hr />
                    <p>
                      Fattura: n° {order.invoice.number} del{' '}
                      {moment(order.invoice.date).format('DD/MM/YYYY')}
                    </p>
                    <p>
                      <A target="_blank" href={downloadUrlInvoice}>
                        Download PDF
                      </A>
                    </p>
                  </span>
                )}
                {!!order.creditMemo.number && (
                  <span>
                    <hr />
                    <p>
                      Nota di credito: n° {order.creditMemo.number} del{' '}
                      {moment(order.creditMemo.date).format('DD/MM/YYYY')}
                    </p>
                    <p>
                      <A target="_blank" href={downloadUrlCreditMemo}>
                        Download PDF
                      </A>
                    </p>
                  </span>
                )}
              </div>
            </div>
          </div>
          <div className="col-sm-8 order-md-1">
            <div className="account-box">
              <h3>Articoli acquistati</h3>
              <div className="scroll-horizontal">
                <table className="table cart">
                  <thead>
                    <tr>
                      <th colSpan="2">Prodotto</th>
                      <th className="text-right">Prezzo</th>
                      <th className="text-right">Quantità</th>
                      <th className="text-right">Subtotale</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.renderCartItems()}
                    <tr>
                      <td></td>
                      <td colSpan="3">Spese di spedizione</td>
                      <td className="subtotal text-right">
                        <Price amount={order.totalShipping} />
                      </td>
                    </tr>
                    {!!order.payment.price && (
                      <tr>
                        <td></td>
                        <td colSpan="3">Spese di incasso (contrassegno)</td>
                        <td className="subtotal text-right">
                          <Price amount={order.payment.price} />
                        </td>
                      </tr>
                    )}
                    {this.renderCoupon(order.coupon, order.items)
                    /*this.renderCoupon(order.coupon, order.totalProducts)*/
                    }
                    <tr className="total-row">
                      <td colSpan="4" className="text-right">
                        Totale
                      </td>
                      <td
                        className="total text-right"
                        style={{ color: primaryColor }}
                      >
                        <Price amount={order.grandTotal} />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-6">
            <div className="account-box">
              <h3>Indirizzo di fatturazione</h3>
              <address style={{ borderColor: primaryColor }}>
                {!!order.billing.isCompany && <p>{order.billing.company}</p>}
                <p>
                  {order.billing.firstname} {order.billing.lastname}
                  <br />
                  {order.billing.address1}
                  <br />
                  {!!order.billing.address2 && (
                    <span>
                      {order.billing.address2}
                      <br />
                    </span>
                  )}
                  {order.billing.zipcode} {order.billing.city} (
                  {order.billing.province})
                </p>
                <p>
                  C.F. {order.billing.taxCode}
                  <br />
                  {!!order.billing.vatNumber && (
                    <span>P.IVA {order.billing.vatNumber}</span>
                  )}
                </p>
                <p>Tel. {order.billing.phone}</p>
              </address>
            </div>
          </div>
          <div className="col-sm-6">
            <div className="account-box">
              <h3>Indirizzo di spedizione</h3>
              <address style={{ borderColor: primaryColor }}>
                <p>
                  {order.shipping.name}
                  <br />
                  {order.shipping.address1}
                  <br />
                  {!!order.shipping.address2 && (
                    <span>
                      {order.shipping.address2}
                      <br />
                    </span>
                  )}
                  {order.shipping.zipcode} {order.shipping.city} (
                  {order.shipping.province})
                </p>
                {order.shipping.country && <p>{order.shipping.country}</p>}
                <p>Tel. {order.shipping.phone}</p>
              </address>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    order: state.singleOrder.data,
    primaryColor: state.store.data.loghiTemplate.brandColor,
    hasTradedoubler: state.store.data.features.hasTradedoubler,
    tradedoubler: state.store.data.integrazioni.tradedoubler,
  };
}

export default connect(mapStateToProps, { loadOrder, payLater, canPayLater })(
  DettaglioOrdine
);
